import React, { useState } from 'react'
import cn from 'classnames'
import { filter, isEmpty, map } from 'lodash'

import Button from '../../Button'
import Keypad from '../TabOrderDetailsKeypad'
import OrderInformation from './OrderInformation'
import SidebarModal from '../../SidebarModal'
import TabOrderItems from '../TabOrderItems'
import { centsToDollars } from '../../../utils/formatters'
import useManagerApproval from '../../../hooks/useManagerApproval'
import confirmationNotification from '../../../hooks/useConfirmationNotification'

import styles from './AdjustPrice.module.scss'

const AdjustPrice = ({
  className,
  frozen,
  itemsWithModifiers,
  onAdjustPrice,
  onClose,
  orderId,
  orderNumber,
  suiteInformation,
  userNotes,
}) => {
  const classNames = cn(styles.adjustPrice, className)
  const [approvalModal, requestApproval] = useManagerApproval()
  const [priceAdjustKeypad, setPriceAdjustKeypad] = useState({show: false, item: {}})
  const [adjustedItemPriceIndex, setAdjustedItemPriceIndex] = useState({ items: {}, totalQuantity: 0 })

  const updateItemPrice = (newPrice, item) => {
    const newTotalQuantity = adjustedItemPriceIndex.items[item.id] ? adjustedItemPriceIndex.totalQuantity : adjustedItemPriceIndex.totalQuantity + item.quantity
    setAdjustedItemPriceIndex({ items: { ...adjustedItemPriceIndex.items, [item.id]: centsToDollars(newPrice) }, totalQuantity: newTotalQuantity })
    setPriceAdjustKeypad({ show: false, item: {} })
  }

  const getFormattedMenuItems = () => {
    return map(
      filter(itemsWithModifiers, item => adjustedItemPriceIndex.items[item.id]),
      item => {
        const newPrice = adjustedItemPriceIndex.items[item.id].slice(1)
        const newPriceInCents = parseInt(newPrice.replace(".", ""))

        return {
          menu_item_uuid: item.id,
          modified_line_item_uuid: item.modifiedLineItemUuid,
          price: newPrice,
          priceInCents: newPriceInCents,
          quantity: 1,
          uuid: item.lineItemUuid,
        }
      }
    )
  }

  const handleOnConfirm = () => {
    confirmationNotification(
      () =>
        requestApproval(() => {
          const orderMenuItems = getFormattedMenuItems();
          onAdjustPrice({
            orderId,
            orderMenuItems,
            totalQuantityUpdated: adjustedItemPriceIndex.totalQuantity,
          })
        }),
      frozen
    )
  }

  const SelectionTitle = ({ title }) => (
    <div className={styles.selectionTitle}>
      {title}
    </div>
  )

  let priceAdjustKeypadElement = null
  if (priceAdjustKeypad.show) {
    priceAdjustKeypadElement = (
      <Keypad
        adjustedItemPriceIndex={adjustedItemPriceIndex}
        decimal={true}
        item={priceAdjustKeypad.item}
        key={'priceAdjustKeypad'}
        onClose={() => setPriceAdjustKeypad({ show: false, item: {} })}
        onConfirm={updateItemPrice}
        title="Enter new Ea. price for "
        interactionType="tap"
      />
    )
  }

  let submitButton = null
  if (!isEmpty(adjustedItemPriceIndex.items)) {
    submitButton = (
      <Button
        className={[styles.actionButton, styles.mintGreenHighlight]}
        key='confirmNewPrices'
        onClick={handleOnConfirm}
      >
        Confirm
      </Button>
    )
  }

  return (
    <SidebarModal
      className={classNames}
      onClose={onClose}
      show
      title="Adjust Price"
    >
      <div className={styles.bodyContainer}>
        <OrderInformation
          account={suiteInformation.displayName}
          hidePayment={true}
          orderNumber={orderNumber}
          note={userNotes}
        />
        <SelectionTitle title="Select Items to adjust" />
        <TabOrderItems
          adjustedItemPriceIndex={adjustedItemPriceIndex}
          className={styles.itemsContainer}
          items={itemsWithModifiers}
          onSelectItem={(item) => setPriceAdjustKeypad({show: true, item})}
        />
        {priceAdjustKeypadElement}
        {approvalModal}
        <div className={styles.buttonContainer}>{submitButton}</div>
      </div>
    </SidebarModal>
  )
}

export default AdjustPrice
